export default "/images/0904bb9dbcc075d2ad65685bdeb8f3a0.avif";